class G_header {
  constructor(public $: any) {
    this.$ = $
  }

  public global_enterfunc(that: any): void {
    const $ = this.$
    let { addBodyStyle, slidedown_element } = G_header.obj_elem(that, $)

    if (slidedown_element === null) return

    that.classList.add('on')
    slidedown_element.classList.add('on')
    addBodyStyle.addClass('scrollstop')
  }

  public global_leavefunc(that: any): void {
    const $ = this.$
    let { addBodyStyle, slidedown_element } = G_header.obj_elem(that, $)

    if (slidedown_element === null) return

    that.classList.remove('on')
    slidedown_element.classList.remove('on')
    addBodyStyle.removeClass('scrollstop')
  }
  public global_clickfunc(that: any): void {
    const $ = this.$
    const flag = '_on'
    let { addBodyStyle, slidedown_element } = G_header.obj_elem(that, $)

    let header_lists = $('#header_list li[data-slide]')
    let nav_drop = $('.nav-drop')
    if ($(that).hasClass(flag)) {
      header_lists.removeClass(flag)
      nav_drop.removeClass(flag)
      addBodyStyle.removeClass('scrollstop')
    } else {
      header_lists.removeClass(flag)
      nav_drop.removeClass(flag)
      $(that).addClass(flag)
      $(slidedown_element).addClass(flag)
      addBodyStyle.addClass('scrollstop')
    }
  }
  static obj_elem(that: any, $: any) {
    const attr_name = 'data-slide'
    const drop = 'nav-drop'
    const get_name = that.getAttribute(attr_name)
    const addBodyStyle = $('body')
    const slidedown = document.getElementsByClassName('slideDown')[0]
    const slidedown_element = slidedown.querySelector(
      `.${drop}` + '_' + `${get_name}`
    )
    return { addBodyStyle, slidedown, slidedown_element }
  }
  public global_follow_header($: any): void {
    let scroll_num: number
    let scroll_go: string = 'scroll-change-state'
    let global_header: any
    let flag: boolean = false
    global_header = $('#global-header')
    let main_comp = global_header

    let scroll_header = () => {
      let main_comp_top = main_comp.innerHeight()
      let main_comp_num = Math.floor(main_comp_top)
      scroll_num = $(window).scrollTop()
      if (scroll_num > main_comp_num) {
        global_header!.addClass(scroll_go)
      } else {
        global_header!.removeClass(scroll_go)
      }
    }

    window.addEventListener('load', function() {
      flag = true
      if (flag) {
        scroll_header()
      }
    })

    window.addEventListener('scroll', function() {
      if (flag) {
        flag = false
        setTimeout(function() {
          scroll_header()
          flag = true
          return flag
        }, 0)
      }
    })
  }

  public global_spHeader_fun(): void {
    const $ = this.$
    const spMenuWrap = document.getElementById('spMenuWrap')
    const spMenuOpen = $('#menuOpen')
    const spMenuClose = $('#menuClose')
    const addBodyStyle = $('body')
    if (spMenuWrap!.classList.contains('on')) {
      G_header.menuOff(spMenuWrap)
      spMenuClose.addClass('none')
      spMenuOpen.removeClass('none')
      addBodyStyle.removeClass('scrollstop')
    } else {
      G_header.menuOn(spMenuWrap)
      spMenuClose.removeClass('none')
      spMenuOpen.addClass('none')
      addBodyStyle.addClass('scrollstop')
    }
  }

  static menuOn(open: any) {
    open.classList.add('on')
  }
  static menuOff(open: any) {
    open.classList.remove('on')
  }
  static menu_slide(_that: any, $: any) {
    if (
      $(_that)
        .parent('.js-drop-nav')
        .hasClass('open_drop')
    ) {
      $(_that)
        .parent('.js-drop-nav')
        .removeClass('open_drop')
      $(_that)
        .next('.nav-drop')
        .css('height', '')
    } else if (
      !$(_that)
        .parent('.js-drop-nav')
        .hasClass('open_drop')
    ) {
      $(_that)
        .parent('.js-drop-nav')
        .addClass('open_drop')
      const inrH: any = $(_that)
        .parent('.js-drop-nav')
        .find('.nav-drop_inner')
        .outerHeight()
      $(_that)
        .next('.nav-drop')
        .css('height', inrH)
    }
  }
}

export default G_header
